<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div class="modal-content scrollable">
  <div class="modal-header">
    <h5 class="modal-title" xdaTranslate>SDE_JOB_STATUS</h5>
  </div>
  <div class="modal-body" tabindex="-1">
    <div id="jobs-container">
      <!-- For each workflow -->
      @for (workflow of workflows; track workflow) {
        <div
          class="job"
          [ngClass]="{
            expanded: expandedWorkflow && expandedWorkflow.id == workflow.id,
          }"
          [@fadeOut]>
          <div class="job-summary">
            <!-- Display icon -->
            <span class="workflow-icon">
              @if (workflow.icon.image) {
                <img class="workflow-image" [src]="workflow.icon.image" />
              } @else {
                <span
                  class="workflow-image {{ workflow.icon.glyph }} {{
                    workflow.icon.color
                  }} xglsize-32 text-center align-middle"></span>
              }
            </span>
            <!-- Display workflow name -->
            <span class="workflow-name">
              <span class="name-wrapper">
                <span class="name" [xdaTranslate]="workflow.name"></span>
                @if (workflow.pageCount) {
                  <span
                    class="count"
                    [xdaTranslate]="'SDE_FMTSTR_PAGES1'"
                    [formatValues]="workflow.pageCount"></span>
                }
              </span>
              <span
                [xdaTranslate]="'SDE_SUBMITTED_FMTSTR'"
                [formatValues]="
                  (workflow.initiatedAt | date: 'medium') || ''
                "></span>
            </span>
            <!-- Display state glyph -->
            <span class="flex-center progress-glyph">
              @if (
                !isTerminalStateArray(workflow.status!) &&
                !isAPendingStateArray(workflow.status!)
              ) {
                <span
                  class="xrx-activity-indicator ai-sm ai-spin"
                  placement="bottom"
                  [ngbTooltip]="
                    'SDE_FMTSTR_PROCESSING' | xdaTranslate: 'SDE_JOB'
                  "></span>
              }
              @if (isErrorStateArray(workflow.status!)) {
                <span
                  class="error xgl-alert xglsize-32"
                  placement="bottom"
                  [ngbTooltip]="
                    'SDE_FMTSTR_ERROR1' | xdaTranslate: 'SDE_JOB'
                  "></span>
              }
              @if (isCompletedStateArray(workflow.status!)) {
                <span
                  class="complete xgl-checkmark_circle_break xglsize-32"
                  placement="bottom"
                  [ngbTooltip]="
                    'SDE_FMTSTR_COMPLETED' | xdaTranslate: 'SDE_JOB'
                  "></span>
              }
              @if (
                isAPendingStateArray(workflow.status!) &&
                !isErrorStateArray(workflow.status!) &&
                !isTerminalStateArray(workflow.status!)
              ) {
                <span
                  class="waiting xgl-alarmclock xglsize-32"
                  placement="bottom"
                  [ngbTooltip]="
                    'SDE_USER_INTERACTION_REQUIRED' | xdaTranslate
                  "></span>
              }
              @if (isCanceledStateArray(workflow.status!)) {
                <span
                  class="close xgl-close xglsize-32"
                  placement="bottom"
                  [ngbTooltip]="
                    'SDE_FMTSTR_CANCELED' | xdaTranslate: 'SDE_JOB'
                  "></span>
              }
            </span>
            <!-- Display buttons -->
          </div>
          @if (expandedWorkflow && workflow.id == expandedWorkflow.id) {
            <div class="job-details">
              <div>
                <div class="input">
                  <!-- Upload file -->
                  <span class="service-name">
                    @if (!workflow.name.includes('MERGE')) {
                      <span [xdaTranslate]="'SDE_UPLOADING_FILE2'"></span>
                    }
                    @if (workflow.name.includes('MERGE')) {
                      <span [xdaTranslate]="'SDE_UPLOADING_FILES'"></span>
                    }
                  </span>
                  <!-- Display state glyph -->
                  <span class="flex-center progress-glyph">
                    @if (
                      (!workflow.status ||
                        !isTerminalStateArray(workflow.status)) &&
                      !workflow.services![0].status
                    ) {
                      <span
                        class="xrx-activity-indicator ai-xs ai-spin"
                        placement="left"
                        [ngbTooltip]="
                          'SDE_FMTSTR_PROCESSING' | xdaTranslate
                        "></span>
                    }
                    @if (
                      workflow.status &&
                      isErrorStateArray(workflow.status) &&
                      !workflow.services![0].status
                    ) {
                      <span
                        class="error xgl-alert xglsize-20"
                        placement="left"
                        [ngbTooltip]="'SDE_ERROR' | xdaTranslate"></span>
                    }
                    @if (
                      (workflow.status &&
                        isCompletedStateArray(workflow.status)) ||
                      workflow.services![0].status
                    ) {
                      <span
                        class="complete xgl-checkmark_circle_break xglsize-20"
                        placement="left"
                        [ngbTooltip]="'SDE_COMPLETE' | xdaTranslate"></span>
                    }
                  </span>
                </div>
                @if (
                  workflow.status &&
                  isErrorStateArray(workflow.status) &&
                  isInsufficientCreditStateArray(workflow.status)
                ) {
                  <div class="entitlements">
                    <span
                      class="service-status"
                      [xdaTranslate]="workflow.status[0].status"></span>
                  </div>
                }
              </div>
              @for (service of workflow.services; track service) {
                <div class="services">
                  <!-- Display service only if it has a status -->
                  @if (service.status) {
                    <div class="service">
                      <!-- Display service name -->
                      <span class="service-name">
                        <span
                          [xdaTranslate]="
                            $any(serviceStatusNames)[service.name] ||
                            service.name
                          "></span>
                      </span>
                      <!-- Display state glyph -->
                      <span class="flex-center progress-glyph">
                        @if (!isTerminalStateArray(service.status)) {
                          <span
                            class="xrx-activity-indicator ai-xs ai-spin"
                            placement="left"
                            [ngbTooltip]="
                              'SDE_PROCESSING1' | xdaTranslate
                            "></span>
                        }
                        @if (isErrorStateArray(service.status)) {
                          <span
                            class="error xgl-alert xglsize-20"
                            placement="left"
                            [ngbTooltip]="'SDE_ERROR' | xdaTranslate"></span>
                        }
                        @if (isCompletedStateArray(service.status)) {
                          <span
                            class="complete xgl-checkmark_circle_break xglsize-20"
                            placement="left"
                            [ngbTooltip]="'SDE_COMPLETE' | xdaTranslate"></span>
                        }
                      </span>
                    </div>
                  }
                </div>
              }
              @for (ostatus of workflow.outputStatus; track ostatus) {
                <div class="outputs">
                  @if (!isPendingPrintState(ostatus)) {
                    <div class="output">
                      <!-- Output file status -->
                      <span class="service-name">
                        <span [xdaTranslate]="ostatus.status"></span>
                      </span>
                      <!-- Display state glyph -->
                      <span class="flex-center progress-glyph">
                        @if (
                          !ostatus ||
                          (ostatus &&
                            !isErrorState(ostatus) &&
                            !isCompletedState(ostatus) &&
                            !isPendingDownloadState(ostatus) &&
                            !isPendingPrintState(ostatus))
                        ) {
                          <span
                            class="xrx-activity-indicator ai-xs ai-spin"
                            placement="left"
                            [ngbTooltip]="
                              'SDE_PROCESSING1' | xdaTranslate
                            "></span>
                        }
                        @if (ostatus && isPendingDownloadState(ostatus)) {
                          <span
                            class="waiting xgl-alarmclock xglsize-20"
                            placement="left"
                            [ngbTooltip]="
                              'SDE_USER_INTERACTION_REQUIRED' | xdaTranslate
                            "></span>
                        }
                        @if (
                          ostatus &&
                          !isErrorState(ostatus) &&
                          isCompletedState(ostatus)
                        ) {
                          <span
                            class="complete xgl-checkmark_circle_break xglsize-20"
                            placement="left"
                            [ngbTooltip]="'SDE_COMPLETE' | xdaTranslate"></span>
                        }
                        @if (ostatus && isErrorState(ostatus)) {
                          <span
                            class="error xgl-alert xglsize-20"
                            placement="left"
                            [ngbTooltip]="'SDE_ERROR' | xdaTranslate"></span>
                        }
                      </span>
                    </div>
                  }
                </div>
              }
              @if (isPendingPrintStateArray(workflow.status!)) {
                <div class="output">
                  <!-- Print ready status -->
                  <span class="service-name">
                    @if (isOutputTypePrint(workflow.output.outputOptions)) {
                      <span [xdaTranslate]="'SDE_ACCESS_JOB_WORKFLOW'"></span>
                    }
                  </span>
                </div>
              }
              <!-- workflow known errors -->
              @if (isErrorStateArray(workflow.status!)) {
                <div class="error">
                  <span class="service-name">
                    <span
                      [xdaTranslate]="getErrorMessage(workflow.status!)"></span>
                  </span>
                </div>
              }
              @if (
                (workflow.status && isErrorStateArray(workflow.status!)) ||
                isCanceledStateArray(workflow.status!)
              ) {
                <div class="error">
                  @if (isCanceledStateArray(workflow.status!)) {
                    <span class="error-status">
                      <span xdaTranslate>SDE_WORKFLOW_CANCELED</span>
                    </span>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>

  <div class="modal-footer">
    <div class="cb">
      <button
        (click)="remove($event, expandedWorkflow)"
        class="xrx-btn btn-secondary">
        <span class="btn-label" xdaTranslate>SDE_EXIT</span>
      </button>
    </div>
    @if (!isTerminalStateArray(expandedWorkflow?.status!)) {
      <div class="cb" [class.disabled]="expandedWorkflow?.waitToBeCanceled">
        <button
          (click)="cancel($event, expandedWorkflow)"
          class="xrx-btn btn-secondary">
          <span class="btn-label" xdaTranslate>SDE_CANCEL</span>
        </button>
      </div>
    }
  </div>
</div>
